// Material UI
import { Grid } from '@mui/material';

// Componentes
import BasicSelect from '@components/Selects/BasicSelect';
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

const AcademyForm = (props) => {
  const { catalogs, isLoading, formik } = props;

  const getFormik = (value) => getFormikUtil(formik, 'academy', value);

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Chip icon={<Icon>school</Icon>} label="Formación Académica" />
      </Grid> */}

      <Grid item xs={12} sm={5} md={3}>
        <BasicSelect
          size="small"
          name="academy.idGrade"
          label="¿Último grado de estudios? *"
          options={catalogs.grados_estudios || []}
          value={getFormik('idGrade')?.value}
          onChange={formik.handleChange}
          isLoading={isLoading}
          error={getFormik('idGrade').error}
          errorMessage={getFormik('idGrade').helperText}
          sx={{ width: '100%' }}
        />
      </Grid>

      <Grid item xs={12} sm={7} md={9}>
        <TextFieldTK
          required
          fullWidth
          name="academy.generalEducation"
          label="¿Formación académica general?"
          value={getFormik('generalEducation')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('generalEducation')?.error}
          helperText={getFormik('generalEducation')?.helperText}
          useTrim
        />
      </Grid>
    </Grid>
  );
};

export default AcademyForm;
